import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Signup from "./auth/Googleauth";
import { FaUserPen } from "react-icons/fa6";
import { SignedIn, SignedOut, UserButton } from "@clerk/clerk-react";
import { FaCartPlus, FaShoppingBag } from "react-icons/fa";
import { setCartLength } from "../redux/features/auth/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from '../redux/Store';

const blindsOptions = [
  { label: "Roller Shades", value: "roller_shades" },
  { label: "Zebra Shades", value: "zebra_shades" },
  // { label: "Wood Blinds", value: "wood_blinds" },
  // { label: "Vertical Blinds", value: "vertical_blinds" },
  // { label: "Honeycomb Blinds", value: "honeycomb_blinds" },
  // { label: "Shangrila Shades", value: "shangrila_shades" },
];

const Navbar = () => {
  const dispatch = useDispatch();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // 🔹 State for mobile menu
  const cartLength = useSelector((state) => state.user.cartLength);
  const [isBlindsDropdownOpen, setIsBlindsDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleBro = () => {
    dispatch(setCartLength(0));
  };

  return (
    <>
      {/* Top Header - Contact & Login */}
      <div className="bg-[#003EA1] text-white py-2 text-sm hidden md:block">
        <div className="container mx-auto flex justify-between items-center">
          <span>📞 Call us: +1 800-123-4567</span>
          <Signup />
        </div>
      </div>

      {/* Sticky Navbar */}
      <nav
        className={`fixed top-0 w-full bg-white shadow-md transition-all ${
          isScrolled ? "py-2 shadow-lg" : "py-4"
        } z-50`}
      >
        <div className="container mx-auto flex justify-between items-center px-6">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <motion.img
              src="https://res.cloudinary.com/dhhsupcai/image/upload/v1726647751/thrd6ytbgmj5fdvlphd7.png"
              alt="Blinds Logo"
              className="h-14"
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex space-x-8">
            {[
              { label: "Home", path: "/" },
              { label: "About Us", path: "/aboutpage" },
              // { label: "Shop", path: "/shop" },
              { label: "Blinds", path: "/shop" },
              { label: "Contact", path: "/contact" },
            ].map((item, index) => (
              item.label === "Blinds" ? (
                <motion.div
                  key={index}
                  className="relative"
                  onMouseEnter={() => setIsBlindsDropdownOpen(true)}
                  whileHover={{ scale: 1.05 }}
                >
                  <Link
                    to={item.path}
                    className="relative text-lg font-semibold text-gray-700 hover:text-[#003EA1] transition-all"
                  >
                    {item.label}
                  </Link>
                  {/* Dropdown */}
                  {isBlindsDropdownOpen && (
                    <div
                      className="absolute left-0 top-full mt-0 w-56 bg-white border border-gray-200 shadow-lg rounded-lg z-50"
                      onMouseEnter={() => setIsBlindsDropdownOpen(true)}
                      onMouseLeave={() => setIsBlindsDropdownOpen(false)}
                    >
                      <ul className="py-2">
                        {blindsOptions.map((opt) => (
                          <li key={opt.value}>
                            <Link
                              to={`/shop?productType=${opt.value}`}
                              className="block px-4 py-2 text-gray-700 hover:bg-[#003EA1] hover:text-white transition-all"
                              onClick={() => setIsBlindsDropdownOpen(false)}
                            >
                              {opt.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </motion.div>
              ) : (
                <motion.div key={index} whileHover={{ scale: 1.05 }}>
                  <Link
                    to={item.path}
                    className="relative text-lg font-semibold text-gray-700 hover:text-[#003EA1] transition-all"
                  >
                    {item.label}
                    <motion.div
                      className="absolute left-0 bottom-0 w-0 h-0.5 bg-[#003EA1] transition-all"
                      whileHover={{ width: "100%" }}
                    />
                  </Link>
                </motion.div>
              )
            ))}
          </div>

          {/* Icons (Cart, Orders, Search) */}
          <div className="hidden lg:flex items-center space-x-6">
            <motion.div
              className="relative"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              <input
                type="text"
                placeholder="Search blinds..."
                className="px-4 py-2 w-60 rounded-full border border-gray-300 shadow-sm focus:ring-2 focus:ring-[#003EA1] focus:border-[#003EA1] transition-all"
              />
              <span className="absolute right-4 top-2 text-gray-400 text-lg">🔍</span>
            </motion.div>

            {/* Orders Icon */}
            <motion.div whileHover={{ scale: 1.2 }} transition={{ duration: 0.3 }}>
              <SignedOut>
                <Link to="/login">
                  <FaShoppingBag />
                </Link>
              </SignedOut>
              <SignedIn>
                <Link to="/order-history">
                  <FaShoppingBag />
                </Link>
              </SignedIn>
            </motion.div>

            {/* Cart Icon */}
            <motion.div
              whileHover={{ scale: 1.2 }}
              transition={{ duration: 0.3 }}
              className="relative"
            >
              <SignedOut>
                <Link to="/login">
                  <FaCartPlus />
                </Link>
              </SignedOut>
              <SignedIn>
                <Link to="/cart">
                  <FaCartPlus onClick={handleBro} />
                </Link>
              </SignedIn>

              {/* Cart Badge */}
              {cartLength > 0 && (
                <div className="absolute -top-2 -right-3 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  <span>{cartLength}</span>
                </div>
              )}
            </motion.div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-[#003EA1]"
            onClick={() => setIsMenuOpen(!isMenuOpen)} // 🔹 Toggle menu
          >
            <svg
              className="h-9 w-9"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>

          {/* User Button */}
          <div className="flex space-x-4">
            <SignedIn>
              <UserButton afterSignOutUrl="/" signOutCallback={() => persistor.purge()} />
            </SignedIn>
            <SignedOut>
              <div className="flex justify-center">
                <Link
                  to="/login"
                  className="px-4 py-2 bg-gradient-to-r from-[#4961cb] via-[#00020a] to-[#01A9DE] text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-300 ease-in-out"
                >
                  <FaUserPen />
                </Link>
              </div>
            </SignedOut>
          </div>
        </div>

        {/* 🔹 Mobile Navigation (Dropdown) */}
        {isMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 w-full bg-white shadow-md z-50 py-4 px-6">
            <ul className="flex flex-col space-y-4">
              {[
                { label: "Home", path: "/" },
                { label: "About Us", path: "/aboutpage" },
                { label: "Shop", path: "/shop" },
                { label: "Blinds", path: "/blinds" },
                { label: "Contact", path: "/contact" },
              ].map((item, index) => (
                item.label === "Blinds" ? (
                  <li key={index}>
                    <button
                      type="button"
                      className="w-full text-left text-lg font-semibold text-gray-700 hover:text-[#003EA1] transition-all flex items-center justify-between"
                      onClick={() => setIsBlindsDropdownOpen((prev) => !prev)}
                    >
                      {item.label}
                      <svg className={`ml-2 w-4 h-4 transform transition-transform ${isBlindsDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
                    </button>
                    {isBlindsDropdownOpen && (
                      <ul className="pl-4 mt-2 space-y-2">
                        {blindsOptions.map((opt) => (
                          <li key={opt.value}>
                            <Link
                              to={`/blinds/${opt.value}`}
                              className="block px-2 py-1 text-gray-700 hover:bg-[#003EA1] hover:text-white rounded transition-all"
                              onClick={() => { setIsBlindsDropdownOpen(false); setIsMenuOpen(false); }}
                            >
                              {opt.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ) : (
                  <li key={index}>
                    <Link
                      to={item.path}
                      className="text-lg font-semibold text-gray-700 hover:text-[#003EA1] transition-all block"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                  </li>
                )
              ))}
            </ul>
          </div>
        )}
      </nav>
    </> 
  );
};

export default Navbar;
